import { Command, InitializationCommand } from "./CommandUtils";
import { getCleanCommaDelimitedList } from "../Features/FeatureUtils";

export const initializeAnimationsCommand: InitializationCommand = (
  _mesh,
  userData,
  commandContext
) => {
  const { Animations: animations = "" } = userData;
  const cleanAnimations = getCleanCommaDelimitedList(animations);
  const {
    animationContext: { playAnimations, stopAnimations },
  } = commandContext;

  stopAnimations(cleanAnimations);

  return () => {
    playAnimations(cleanAnimations);
  };
};

export const playAnimationsCommand: Command = (
  _mesh,
  userData,
  commandContext
) => {
  const { Animations: animations = "" } = userData;
  const cleanAnimations = getCleanCommaDelimitedList(animations);
  const {
    animationContext: { playAnimations },
  } = commandContext;

  return playAnimations(cleanAnimations);
};
